import {z} from 'zod';

import {promptSchema} from './PromptSchema';

/**
 * Schema for single prompt response
 */
export const promptResponseSchema = z.object({
  prompt: promptSchema,
});

export type PromptResponse = z.infer<typeof promptResponseSchema>;
